export default __webpack_public_path__ + "static/media/mobile-home.5f996941.png";